import { request } from '@/api/http';
import type { BillingCheckoutResult, BillingPortalResult, BillingStatus } from '@/api/types';

export const billingService = {
  status: (userId?: string) => {
    const q = userId ? `?user_id=${encodeURIComponent(userId)}` : '';
    return request<BillingStatus>(`/billing/status${q}`);
  },
  checkout: (plan: string, userId?: string) =>
    request<BillingCheckoutResult>('/billing/checkout', {
      method: 'POST',
      body: JSON.stringify({ plan, user_id: userId ?? null }),
    }),
  portal: (userId?: string) =>
    request<BillingPortalResult>('/billing/portal', {
      method: 'POST',
      body: JSON.stringify({ user_id: userId ?? null }),
    }),
};
